import React, { useEffect, useState } from 'react';
import styles from './ProgressNav.module.css';
import ProgressNavNode from './ProgressNavNode';
import { PROGRESS_NODES } from '../../utils/constants/progressSteps';
import { useAppContext } from '../../utils/ContextProviders/AppContext';

function ProgressNavBar() {
  const { viewSize, currentStep } = useAppContext();
  const [currentNode, setCurrentNode] = useState(-1);
  useEffect(() => {
    const getCurrentNode = () => {
      const index = PROGRESS_NODES.findIndex(
        (x) => x.title.toLowerCase() === currentStep.toLowerCase(),
      );
      setCurrentNode(index);
    };

    getCurrentNode();
  }, [currentStep]);
  return (
    <div className={`${styles.navigation} ${styles[viewSize]}`}>
      {PROGRESS_NODES.map((node, index) => {
        const selected = index <= currentNode;
        return (
          <ProgressNavNode
            key={node.title}
            number={`${index + 1}`}
            item={node}
            selected={selected}
          />
        );
      })}
    </div>
  );
}

export default ProgressNavBar;
